var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 43,
    height: 43,
    rx: 8,
    fill: "#FFEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5238 23.8575C21.2381 23.8575 21.0476 23.7623 20.8571 23.5718L18 20.7147C17.619 20.3337 17.619 19.7623 18 19.3813C18.381 19.0004 18.9524 19.0004 19.3333 19.3813L21.5238 21.5718L30.381 12.7147C30.7619 12.3337 31.3333 12.3337 31.7143 12.7147C32.0952 13.0956 32.0952 13.667 31.7143 14.048L22.1905 23.5718C22 23.7623 21.8095 23.8575 21.5238 23.8575ZM31.0476 27.667V21.0004C31.0476 20.4289 30.6667 20.048 30.0952 20.048C29.5238 20.048 29.1429 20.4289 29.1429 21.0004V27.667C29.1429 28.2385 28.7619 28.6194 28.1905 28.6194H14.8571C14.2857 28.6194 13.9048 28.2385 13.9048 27.667V14.3337C13.9048 13.7623 14.2857 13.3813 14.8571 13.3813H25.3333C25.9048 13.3813 26.2857 13.0004 26.2857 12.4289C26.2857 11.8575 25.9048 11.4766 25.3333 11.4766H14.8571C13.2381 11.4766 12 12.7147 12 14.3337V27.667C12 29.2861 13.2381 30.5242 14.8571 30.5242H28.1905C29.8095 30.5242 31.0476 29.2861 31.0476 27.667Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5a54bccb4a5e66d34b0c7c1f3a6af51b.svg";
export { ForwardRef as ReactComponent };